import { createContext, useContext, useMemo } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children, userCode }) => {
  const theme = useMemo(() => {
    const code = (userCode || '').toString().toUpperCase();

    if (code.startsWith('MP421')) {
      return {
        primary: {
          bg: 'bg-mp4212-600',
          bgHover: 'hover:bg-mp4212-700',
          text: 'text-mp4212-600',
          border: 'border-mp4212-600',
          bgLight: 'bg-mp4212-50',
        },
        category: {
          bg: 'bg-mp421-category',
        },
        colors: {
          primary: '#006F3D',
          primaryLight: '#E9F6EE',
          primaryDark: '#005A33',
        }
      };
    }

    if (code.startsWith('MP425')) {
      return {
        primary: {
          bg: 'bg-mp425-600',
          bgHover: 'hover:bg-mp425-700',
          text: 'text-mp425-600',
          border: 'border-mp425-600',
          bgLight: 'bg-mp425-50',
        },
        category: {
          bg: 'bg-mp425-category',
        },
        colors: {
          primary: '#665949',
          primaryLight: '#F4F1EE',
          primaryDark: '#665949',
        }
      };
    }

    if (code.startsWith('MP405')) {
      return {
        primary: {
          bg: 'bg-teal-600',
          bgHover: 'hover:bg-teal-700',
          text: 'text-teal-600',
          border: 'border-teal-600',
          bgLight: 'bg-teal-50',
        },
        colors: {
          primary: '#0d9488',
          primaryLight: '#f0fdfa',
          primaryDark: '#115e59',
        }
      };
    }

    // default teal for others
    return {
      primary: {
        bg: 'bg-teal-600',
        bgHover: 'hover:bg-teal-700',
        text: 'text-teal-600',
        border: 'border-teal-600',
        bgLight: 'bg-teal-50',
      },
      colors: {
        primary: '#0d9488',
        primaryLight: '#f0fdfa',
        primaryDark: '#115e59',
      }
    };
  }, [userCode]);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
